import { getBoolean } from "../utils";

export type TBooleanProperty = {
	value: boolean;
	epoch: number;
} | undefined;

export const convertToBooleanProperty = (value: boolean | string | number | undefined, epoch: string): TBooleanProperty | undefined => {
	if (!value || !epoch) {
		return undefined;
	}

	return {
		value: getBoolean(value),
		epoch: Number.parseInt(epoch, 10),
	};
};
